import { Vector2Tuple } from 'three';

import { AnnotationShallowNode } from '@spazious/dollhouse-shallow-graph';

import { AnnotationNode, FNodeTypesEnum } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class AnnotationNodeImpl extends BaseNodeImpl implements AnnotationNode {
  type: FNodeTypesEnum.Annotation = FNodeTypesEnum.Annotation;
  shallow: AnnotationShallowNode | null = null;
  id: number = 0;
  position: Vector2Tuple = [0, 0];
  visible: boolean = true;
  text: string = '';
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      id: this.id,
      position: this.position,
      visible: this.visible,
      shallow: this.shallow,
      text: this.text,
    };
  }
}
